export default __webpack_public_path__ + "static/media/nftSystemBg.edc6b1a3.png";